import { hasPermission } from '@/utils/permission'

/**
 * v-permission 按钮权限指令：
 *   v-permission="'ops:workorder:writeoff'"          单权限
 *   v-permission="['ops:workorder:review', ...]"     任一命中即显示
 * 无权限时直接移除元素（后端 @RequirePermission 仍是最终防线）。
 */
function check(value) {
  if (!value) return true
  const keys = Array.isArray(value) ? value : [value]
  return keys.some((k) => hasPermission(k))
}

export const permission = {
  mounted(el, binding) {
    if (!check(binding.value)) {
      el.parentNode?.removeChild(el)
    }
  }
}

export function setupPermissionDirective(app) {
  app.directive('permission', permission)
}
